// changeAssetId.js
'use strict';
import getOperationData from '../selector/getOperationData.js';
import getAssetData from '../selector/getAssetData.js';
import getMessageData from '../selector/getMessageData.js';

import {
  Purpose as AssetPurpose,
  ArtifactType,
} from '../resource/assetConstants.js';
import uploadJobReferences from '../resource/uploadJobReferences.js';
import { upload as uploadDebug } from '../resource/debug.js';

import {
  MERGE_OPERATION_DATA,
  MERGE_ASSET_DATA,
  REMOVE_ASSET_DATA,
  ADD_MESSAGES,
} from '../ActionTypes.js';

const uploadLog = uploadDebug.extend('log:action/changeAssetId.js');

/**
 * Change current asset id to new asset id.
 * @kind action
 * @param {string} {oldId} - current asset id.
 * @param {string} {newId} - new asset id.
 * @param {string} {uploadJobId} - upload job id.
 * @return {Promise} Action promise.
 */
const changeAssetId =
  ({ oldId, newId, uploadJobId }) =>
  async (dispatch, getState) => {
    uploadLog('execute changeAssetId', {
      asset: getAssetData(getState(), [oldId]),
      uploadJob: getOperationData(getState(), ['uploadJob', uploadJobId]),
    });
    const file = uploadJobReferences.get(`${oldId}:media:file`);
    uploadJobReferences.set(`${newId}:media:file`, file);
    uploadJobReferences.set(`${oldId}:media:file`, undefined);
    Object.values(ArtifactType).forEach(artifactType => {
      const file = uploadJobReferences.get(`${oldId}:${artifactType}:file`);
      if (file) {
        uploadJobReferences.set(`${newId}:${artifactType}:file`, file);
        uploadJobReferences.set(`${oldId}:${artifactType}:file`, undefined);
      }
    });
    const currentAssetData = getAssetData(getState(), [oldId]) || {};
    const { purpose } = currentAssetData;
    dispatch({
      type: MERGE_ASSET_DATA,
      payload: {
        selectPath: [newId],
        data: {
          ...currentAssetData,
          id: newId,
        },
      },
    });
    const [assetIds, artifactAssetIds] = ['assetIds', 'artifactAssetIds'].map(
      key => {
        const ids =
          getOperationData(getState(), ['uploadJob', uploadJobId], key) || [];
        const index = ids.indexOf(oldId);
        if (index >= 0) {
          ids.splice(index, 1, newId);
        }
        return ids;
      }
    );
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['uploadJob', uploadJobId],
        data: {
          assetIds,
          artifactAssetIds,
        },
      },
    });
    const messageId = getOperationData(
      getState(),
      ['uploadJob', uploadJobId],
      'messageId'
    );
    if (messageId) {
      const assetFieldName =
        purpose === AssetPurpose.AUP ? 'aupAssetIds' : 'assetIds';
      const assetIds =
        getMessageData(getState(), messageId, assetFieldName) || [];
      assetIds.splice(assetIds.indexOf(oldId), 1, newId);
      dispatch({
        type: ADD_MESSAGES,
        payload: {
          messages: {
            [messageId]: {
              [assetFieldName]: assetIds,
            },
          },
        },
      });
    }
    dispatch({
      type: REMOVE_ASSET_DATA,
      payload: {
        selectPath: [oldId],
      },
    });
    return uploadLog('finish changeAssetId', {
      asset: getAssetData(getState(), [newId]),
      uploadJob: getOperationData(getState(), ['uploadJob', uploadJobId]),
    });
  };

export default changeAssetId;
